<table mat-table [dataSource]="calls" class="full-width">
  <ng-container matColumnDef="number">
    <th mat-header-cell *matHeaderCellDef> Numero </th>
    <td mat-cell *matCellDef="let call" class="title">
      <a class="call-link" routerLinkActive="actived" [routerLink]="'/cliente/chamados/' + call.identifier">
        #{{call.number}}
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let call">
      <mat-chip-list aria-label="Fish selection">
        <mat-chip [class]="classesByState(call)">{{call.status_detail.text.toUpperCase()}}</mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="business">
    <th mat-header-cell *matHeaderCellDef> Empresa </th>
    <td mat-cell *matCellDef="let call"> {{call.business != null ? call.business.name : "EMPRESA NÃO DEFINIDA"}} </td>
  </ng-container>

  <ng-container matColumnDef="business_user">
    <th mat-header-cell *matHeaderCellDef> Solicitante </th>
    <td mat-cell *matCellDef="let call"> {{call.business_user != null ? call.business_user.name : "SOLICITANTE NÃO DEFINIDA"}} </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef> Tipo de Chamado </th>
    <td mat-cell *matCellDef="let call"> {{call.type_detail.text}} </td>
  </ng-container>

  <ng-container matColumnDef="user">
    <th mat-header-cell *matHeaderCellDef> Responsável </th>
    <td mat-cell *matCellDef="let call"> {{call.user != null ? call.user.name : ''}} </td>
  </ng-container>

  <ng-container matColumnDef="options">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let call" style="text-align: right;">
      <button
        mat-icon-button
        color="link"
        (click)="goToCall(call)"
      ><mat-icon>launch</mat-icon></button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
